// removed by extract-text-webpack-plugin
module.exports = {"component":"_1sfMz-IG2WuECXH23QxBpF"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Pages/Appointments/Scheduling/Rules/SchedulingRules.css
// module id = 1416
// module chunks = 0